import { ComponentState as AntdComponentState } from "@empglabs/backoffice-ui-kit"

const ComponentState = props => {
  return <AntdComponentState {...props} />
}
export default ComponentState
